import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "к ставке", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Бонусы", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "посмотреть историю накоплений", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_tooltip_with_content = _resolveComponent("ui-tooltip-with-content")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_default_transition = _resolveComponent("default-transition")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_increased_rate_modal = _resolveComponent("increased-rate-modal")!
  const _component_welcome_cashback_modal = _resolveComponent("welcome-cashback-modal")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "containerRef",
    class: _normalizeClass(_ctx.$style.container)
  }, [
    ($setup.isRateIncreased)
      ? (_openBlock(), _createBlock(_component_ui_tooltip_with_content, {
          key: $setup.containerWidth,
          placement: "bottom",
          offset: [-15, 20],
          interactive: "",
          visible: $setup.isIncreasedRateTooltipVisible,
          theme: "dark",
          onHide: $setup.onCloseRateTooltip
        }, {
          trigger: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.increasedRate),
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isIncreasedRateModalOpen = true))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.increasedRateRow)
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.$style.percent)
                }, "+5%", 2),
                _hoisted_1
              ], 2),
              _createElementVNode("p", null, "Осталось " + _toDisplayString(3 - $setup.ordersCounter) + " " + _toDisplayString($setup.declinationByNumber(3 - $setup.ordersCounter, 'заявка|заявки|заявок')), 1)
            ], 2)
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.$style.tooltip)
            }, " Здесь отображается информация о том, сколько заявок с повышенной ценой у вас осталось ", 2)
          ]),
          _: 1
        }, 8, ["visible", "onHide"]))
      : _createCommentVNode("", true),
    ($setup.isShowLoyaltyCoinsCount)
      ? (_openBlock(), _createBlock(_component_ui_tooltip_with_content, {
          key: $setup.containerWidth,
          placement: "bottom",
          offset: [-17, 15],
          interactive: "",
          visible: $setup.isCashbackTooltipVisible,
          theme: "dark",
          onHide: $setup.onCloseCashbackTooltip
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_default_transition, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent($setup.cashbackContainerComponent), {
                  class: _normalizeClass(_ctx.$style.loyaltyBalance),
                  to: $setup.getOrgSectionRoute('org-loyalty-program'),
                  onClick: $setup.onClickLoyaltyLink
                }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createElementVNode("p", {
                      class: _normalizeClass(_ctx.$style.loyaltyCoinsCount)
                    }, [
                      _createVNode(_component_svg_icon, {
                        name: "coins",
                        class: _normalizeClass(_ctx.$style.loyaltyCoinsIcon)
                      }, null, 8, ["class"]),
                      _createTextVNode(" " + _toDisplayString($setup.formatPriceWithoutCurrency($setup.cashbackAvailable, 0)), 1)
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["class", "to", "onClick"]))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.$style.tooltip)
            }, " Здесь отображается информация о ваших бонусах ", 2)
          ]),
          _: 1
        }, 8, ["visible", "onHide"]))
      : _createCommentVNode("", true),
    ($setup.currentLoyaltyStatusDesc)
      ? (_openBlock(), _createBlock(_component_ui_tooltip_with_content, {
          key: 2,
          placement: "bottom",
          offset: [-10, 8],
          interactive: "",
          visible: false
        }, {
          trigger: _withCtx(() => [
            ($setup.userFirstLetterName)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.firstLetter)
                }, _toDisplayString($setup.userFirstLetterName), 3))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", null, "Ваш статус «" + _toDisplayString($setup.currentLoyaltyStatusDesc) + "»,", 1),
            _hoisted_3,
            _createElementVNode("p", null, [
              _createTextVNode(" вы можете в "),
              _createVNode(_component_router_link, {
                to: $setup.getOrgSectionRoute('org-loyalty-program'),
                class: _normalizeClass(_ctx.$style.link)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" личном кабинете ")
                ]),
                _: 1
              }, 8, ["to", "class"])
            ])
          ]),
          _: 1
        }))
      : ($setup.userFirstLetterName)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(_ctx.$style.firstLetter)
          }, _toDisplayString($setup.userFirstLetterName), 3))
        : _createCommentVNode("", true),
    _createVNode(_component_router_link, {
      class: _normalizeClass(_ctx.$style.userInfo),
      to: $setup.getOrgSectionRoute('org')
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString($setup.userName), 1),
        ($setup.showCompanyName)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(_ctx.$style.company)
            }, _toDisplayString($setup.legalFormName) + " " + _toDisplayString($setup.companyName), 3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "to"]),
    ($setup.isIncreasedRateModalOpen)
      ? (_openBlock(), _createBlock(_component_increased_rate_modal, {
          key: 4,
          onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.isIncreasedRateModalOpen = false))
        }))
      : _createCommentVNode("", true),
    ($setup.isWelcomeCashbackModalOpen)
      ? (_openBlock(), _createBlock(_component_welcome_cashback_modal, {
          key: 5,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.isWelcomeCashbackModalOpen = false))
        }))
      : _createCommentVNode("", true)
  ], 2))
}